import api from './api'

export const ordenTallerService = {
  /**
   * Lista ordenes de taller con filtros opcionales.
   * @param {Object} filtros - { estado, fecha_desde, fecha_hasta, cliente_id, busqueda }
   */
  listar(filtros = {}) {
    return api.get('/ordenes-taller', { params: filtros })
  },

  /**
   * Obtiene una orden de taller con sus detalles.
   * @param {number} id
   */
  obtener(id) {
    return api.get(`/ordenes-taller/${id}`)
  },

  /**
   * Crea una nueva orden de taller.
   * @param {Object} datos - { cliente_id, propietario_nombre, placa, marca, modelo, detalles[], ... }
   */
  crear(datos) {
    return api.post('/ordenes-taller', datos)
  },

  /**
   * Actualiza una orden de taller existente.
   * @param {number} id
   * @param {Object} datos
   */
  actualizar(id, datos) {
    return api.put(`/ordenes-taller/${id}`, datos)
  },

  /**
   * Cambia el estado de una orden de taller.
   * @param {number} id
   * @param {string} estado
   * @param {string|null} motivoCancelacion
   */
  cambiarEstado(id, estado, motivoCancelacion = null) {
    return api.patch(`/ordenes-taller/${id}/estado`, {
      estado,
      motivo_cancelacion: motivoCancelacion
    })
  },

  /**
   * Obtiene los datos de la orden para pre-cargar el formulario de facturación.
   * NO emite la factura.
   * @param {number} id
   */
  convertir(id) {
    return api.post(`/ordenes-taller/${id}/convertir`)
  },

  /**
   * Confirma la conversión: marca la orden como 'facturada' y vincula la factura.
   * @param {number} id         - ID de la orden de taller
   * @param {number} facturaId  - ID de la factura emitida
   */
  confirmarConversion(id, facturaId) {
    return api.post(`/ordenes-taller/${id}/confirmar-conversion`, { factura_id: facturaId })
  }
}
